<div class="card shadow-sm mb-5 mb-xl-10">
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bold fs-3 mb-1">{{ 'DASHBOARD.ORG_STATS_TITLE' | translate }}</span>
        <span class="text-muted fw-semibold fs-7">{{ 'DASHBOARD.ORG_STATS_SUBTITLE' | translate }}</span>
      </h3>
      <div class="card-toolbar d-flex flex-wrap gap-2" data-kt-buttons="true">
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-sm btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary"
            [class.active]="currentPeriod === 'month'" [disabled]="isLoading" (click)="changePeriod('month')">
            {{ 'DASHBOARD.FILTER.MONTH' | translate }}
          </button>
          <button type="button" class="btn btn-sm btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary"
            [class.active]="currentPeriod === '3months'" [disabled]="isLoading" (click)="changePeriod('3months')">
            {{ 'DASHBOARD.FILTER.3MONTHS' | translate }}
          </button>
          <button type="button" class="btn btn-sm btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary"
            [class.active]="currentPeriod === '6months'" [disabled]="isLoading" (click)="changePeriod('6months')">
            {{ 'DASHBOARD.FILTER.6MONTHS' | translate }}
          </button>
          <button type="button" class="btn btn-sm btn-outline btn-outline-dashed btn-outline-primary btn-active-light-primary"
            [class.active]="currentPeriod === 'year'" [disabled]="isLoading" (click)="changePeriod('year')">
            {{ 'DASHBOARD.FILTER.YEAR' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="card-body pt-3">
      <!-- Filtry organizacji -->
      <div class="mb-4" *ngIf="allOrganizations.length > 0 && initialOrgLoadComplete">
        <button class="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-between w-100 mb-2"
          type="button" (click)="isCollapsed = !isCollapsed">
          <span>{{ 'DASHBOARD.FILTER.ORG_FILTER' | translate }}</span>
          <i class="bi" [ngClass]="isCollapsed ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
        </button>
        <div [class.collapse]="true" [class.show]="!isCollapsed" id="orgFilterCollapse">
          <div class="p-3 rounded bg-body-tertiary shadow-sm">
            <div class="d-flex justify-content-start gap-3 mb-3 border-bottom pb-2">
              <button type="button" class="btn btn-link btn-sm text-decoration-none p-0" (click)="selectAllOrgs()"
                [disabled]="isLoading || allOrganizations.length === 0">
                <i class="bi bi-check-square-fill me-1"></i> {{ 'DASHBOARD.FILTER.SELECT_ALL' | translate }}
              </button>
              <button type="button" class="btn btn-link btn-sm text-decoration-none p-0" (click)="deselectAllOrgs()"
                [disabled]="isLoading || allOrganizations.length === 0">
                <i class="bi bi-square me-1"></i> {{ 'DASHBOARD.FILTER.DESELECT_ALL' | translate }}
              </button>
            </div>
            <div class="row g-2">
              <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let org of allOrganizations">
                <div class="form-check form-check-sm d-flex align-items-center gap-2">
                  <input class="form-check-input" type="checkbox" [id]="'org-' + org"
                    [(ngModel)]="selectedOrganizations[org]" (ngModelChange)="onOrganizationSelectionChange()"
                    [disabled]="isLoading" />
                  <label class="form-check-label text-truncate mb-0" [for]="'org-' + org" [title]="org">
                    {{ org }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-4 text-muted" *ngIf="!initialOrgLoadComplete && isLoading">
        <i class="bi bi-hourglass-split me-1"></i> {{ 'DASHBOARD.FILTER.LOADING' | translate }}
      </div>
  
      <!-- Pierwszy wykres -->
      <h4 class="mb-3">{{ 'DASHBOARD.CHART.TOTAL_MINUTES' | translate }}</h4>
      <div class="custom-legend mb-3 d-flex flex-wrap gap-3" *ngIf="!isLoading && lastProcessedOrgs && lastProcessedOrgs.length > 0">
        <div *ngFor="let orgData of lastProcessedOrgs; let i = index"
          class="legend-item d-flex align-items-center clickable"
          (click)="handleLegendItemClick(orgData.orgName, 'minutes')"
          [title]="'Pokaż szczegóły dla ' + orgData.orgName + ' w całym okresie'">
          <span class="legend-marker me-1 flex-shrink-0" [style.background-color]="orgData.color || '#CCCCCC'"></span>
          <span class="legend-label text-truncate me-1">{{ orgData.orgName }}</span>
          <span class="legend-trend-arrow small fw-semibold" [style.color]="getTrendIndicator(orgData.trend).color" [title]="getTrendIndicator(orgData.trend).text">
            {{ getTrendIndicator(orgData.trend).arrow }}
          </span>
        </div>
      </div>
      <div class="my-4 chart-status-container">
        <div *ngIf="isLoading && initialOrgLoadComplete" class="d-flex align-items-center justify-content-center gap-2 text-primary p-5">
          <div class="spinner-border spinner-border-sm" role="status"></div>
          <span>{{ 'DASHBOARD.CHART.LOADING' | translate }}</span>
        </div>
        <div *ngIf="errorMessage && !isLoading" class="alert alert-danger text-center">
          <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ 'DASHBOARD.CHART.ERROR' | translate }}: {{ errorMessage }}
        </div>
        <div *ngIf="!isLoading && !errorMessage && lastRawData.length === 0 && initialOrgLoadComplete" class="alert alert-info text-center">
          <i class="bi bi-info-circle-fill me-2"></i> {{ 'DASHBOARD.CHART.NO_DATA_PERIOD' | translate }}
        </div>
        <div *ngIf="!isLoading && !errorMessage && lastRawData.length > 0 && (chartOptions?.series?.length === 0) && initialOrgLoadComplete" class="alert alert-warning text-center">
          <i class="bi bi-funnel-fill me-2"></i> {{ 'DASHBOARD.CHART.NO_DATA_FILTERED' | translate }}
        </div>
      </div>
      <div *ngIf="chartOptions?.series?.length && !isLoading && !errorMessage" class="mt-3">
        <apx-chart #statsChart
          [series]="chartOptions.series!"
          [chart]="chartOptions.chart!"
          [xaxis]="chartOptions.xaxis!"
          [yaxis]="chartOptions.yaxis!"
          [stroke]="chartOptions.stroke!"
          [tooltip]="chartOptions.tooltip!"
          [dataLabels]="chartOptions.dataLabels!"
          [legend]="chartOptions.legend!"
          [fill]="chartOptions.fill!"
          [states]="chartOptions.states!"
          [colors]="chartOptions.colors!"
          [plotOptions]="chartOptions.plotOptions!"
          [responsive]="chartOptions.responsive!">
        </apx-chart>
      </div>
  
      <!-- Drugi wykres -->
      <h4 class="mt-5 mb-3">{{ 'DASHBOARD.CHART.TOTAL_DURATION' | translate }}</h4>
      <div class="custom-legend mb-3 d-flex flex-wrap gap-3" *ngIf="!isLoading && lastProcessedOrgsDuration && lastProcessedOrgsDuration.length > 0">
        <div *ngFor="let orgData of lastProcessedOrgsDuration; let i = index"
          class="legend-item d-flex align-items-center clickable"
          (click)="handleLegendItemClick(orgData.orgName, 'duration')"
          [title]="'Pokaż szczegóły dla ' + orgData.orgName + ' w całym okresie'">
          <span class="legend-marker me-1 flex-shrink-0" [style.background-color]="orgData.color || '#CCCCCC'"></span>
          <span class="legend-label text-truncate me-1">{{ orgData.orgName }}</span>
          <span class="legend-trend-arrow small fw-semibold" [style.color]="getTrendIndicator(orgData.trend).color" [title]="getTrendIndicator(orgData.trend).text">
            {{ getTrendIndicator(orgData.trend).arrow }}
          </span>
        </div>
      </div>
      <div class="my-4 chart-status-container">
        <div *ngIf="isLoading && initialOrgLoadComplete" class="d-flex align-items-center justify-content-center gap-2 text-primary p-5">
          <div class="spinner-border spinner-border-sm" role="status"></div>
          <span>{{ 'DASHBOARD.CHART.LOADING' | translate }}</span>
        </div>
        <div *ngIf="errorMessage && !isLoading" class="alert alert-danger text-center">
          <i class="bi bi-exclamation-triangle-fill me-2"></i> {{ 'DASHBOARD.CHART.ERROR' | translate }}: {{ errorMessage }}
        </div>
        <div *ngIf="!isLoading && !errorMessage && lastRawData.length === 0 && initialOrgLoadComplete" class="alert alert-info text-center">
          <i class="bi bi-info-circle-fill me-2"></i> {{ 'DASHBOARD.CHART.NO_DATA_PERIOD' | translate }}
        </div>
        <div *ngIf="!isLoading && !errorMessage && lastRawData.length > 0 && (chartOptionsDuration?.series?.length === 0) && initialOrgLoadComplete" class="alert alert-warning text-center">
          <i class="bi bi-funnel-fill me-2"></i> {{ 'DASHBOARD.CHART.NO_DATA_FILTERED' | translate }}
        </div>
      </div>
      <div *ngIf="chartOptionsDuration?.series?.length && !isLoading && !errorMessage" class="mt-3">
        <apx-chart #statsChartDuration
          [series]="chartOptionsDuration.series!"
          [chart]="chartOptionsDuration.chart!"
          [xaxis]="chartOptionsDuration.xaxis!"
          [yaxis]="chartOptionsDuration.yaxis!"
          [stroke]="chartOptionsDuration.stroke!"
          [tooltip]="chartOptionsDuration.tooltip!"
          [dataLabels]="chartOptionsDuration.dataLabels!"
          [legend]="chartOptionsDuration.legend!"
          [fill]="chartOptionsDuration.fill!"
          [states]="chartOptionsDuration.states!"
          [colors]="chartOptionsDuration.colors!"
          [plotOptions]="chartOptionsDuration.plotOptions!"
          [responsive]="chartOptionsDuration.responsive!">
        </apx-chart>
      </div>
    </div>
  </div>
  